module.exports = __webpack_public_path__ + "media/images/gallery/pn_s-60dbbcc02230576bf0695859cdfeefb2.gif";